module.exports = __webpack_public_path__ + "img/scb.0bed6e8f.png";